import { render, staticRenderFns } from "./tindex2.vue?vue&type=template&id=40f1ed35&"
import script from "./tindex2.vue?vue&type=script&lang=js&"
export * from "./tindex2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports